'use client';

import Link from 'next/link';
import { Button } from '../../../ui/button';
import { HousePlus } from 'lucide-react';
import { NavbarCurrencySwitcher } from '../../Utilities/NavbarCurrencySwitcher';
import { Separator } from '@/components/ui/separator';
import { SignInButton, SignUpButton } from '@clerk/nextjs';
import { cn } from '@/lib/utils';

export default function SignedOutDesktopLinks({ color }: { color: 'black' | 'white' }) {
  return (
    <>
      {/* Show only on desktop */}
      <div className="hidden sm:flex sm:flex-row gap-2 items-center ">
        <Link href="/hosting">
          <Button size="lg">
            <HousePlus className="w-6 h-6 mr-2" /> Add Your Property
          </Button>
        </Link>
        <NavbarCurrencySwitcher color={color} variant={'ghost'} />
        <div className="flex items-center gap-0 justify-center">
          <SignUpButton forceRedirectUrl={'/'}>
            <Button
              variant={'link'}
              className={cn('font-black', color === 'black' ? 'text-black' : 'text-white')}
            >
              CREATE ACCOUNT
            </Button>
          </SignUpButton>
          <Separator
            orientation="vertical"
            className={cn(
              'h-4 font-bold',
              color === 'black' ? 'text-black bg-black' : 'text-white bg-white'
            )}
          />
          <SignInButton>
            <Button
              variant={'link'}
              className={cn('font-black', color === 'black' ? 'text-black' : 'text-white')}
            >
              LOG IN
            </Button>
          </SignInButton>
        </div>
      </div>
    </>
  );
}
